import React, { Children, Fragment, useEffect } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { useEditorContext } from '@philips-internal/oswald-ui-core/lib/component/index.js';
import { arrayOf, element, expression, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { useWizard } from '../wizard/wizard-context.js';
import { WizardStepGroupContainer } from './internal-wizard-step-group.js';
import { WizardStepGroupAPI } from './wizard-step-group-api.js';
function WizardStepGroup(props) {
    const { children, identifier } = props;
    const wizardContext = useWizard();
    const editorContext = useEditorContext();
    useEffect(() => {
        wizardContext.addGroup(props);
        return () => {
            wizardContext.removeGroup(identifier);
        };
    }, [identifier, children]);
    if (!editorContext?.isDesigning() && !Children.toArray(children).length) {
        throw Error('[Wizard]: Groups must have at least one step.');
    }
    return (React.createElement(Fragment, null, children));
}
WizardStepGroup.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    identifier: string,
    title: expression,
    uuid: string,
};
const awesomeProps = {
    api: WizardStepGroupAPI,
    containers: [WizardStepGroupContainer],
    type: ComponentType.FORM,
};
AwesomeComponent(awesomeProps)(WizardStepGroup);
export { WizardStepGroup, };
//# sourceMappingURL=wizard-step-group.js.map